import styled from "styled-components";

export const EditTournamentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
`;

export const EditTournamentHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin: 48px 0 0;
  border-bottom: 1px solid #f0f0f0;
`;

export const EditTournamentContentWrapper = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  padding: 20px 16px 120px;
  background: #f8f8f8;
  box-sizing: border-box;
  overflow-y: auto;
`;

export const EditTournamentHeaderButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 12px 16px;

  > .button {
    display: flex;
    padding: 8px 12px;
    justify-content: center;
    align-items: center;
    border-radius: 14px;
    background: #f0f0f0;
    color: #444;
    text-align: center;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
    cursor: pointer;
  }
`;

export const EditTournamentDropBoxWrapper = styled.div`
  display: flex;
  width: 146.031px;
  height: 38px;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 14px;
  border: 1px solid #e5e5e5;
  background: #fff;
  background: #ffffff;
  justify-content: center;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  font-weight: 600;
  font-size: 14px;
  font-family: Pretendard;

  > img {
    width: 8px;
    height: 7px;
  }
`;

export const EditTournamentDropBoxItemWrapper = styled.div`
  position: absolute;
  border-radius: 8px;
  gap: 4px;
  box-shadow: 0px 0px 8px 0px #0000001f;
  top: 44px;
  right: 0;
  z-index: 1000;
  background: #fff;
  display: flex;
  flex-direction: column;
  width: auto;
  overflow: hidden;
`;

export const EditTournamentDropBoxItem = styled.div<{ selected: boolean }>`
  white-space: nowrap;
  width: auto;
  height: 30px;
  padding: 0 12px;
  box-sizing: border-box;
  text-align: center;
  gap: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${(p) => (p.selected ? "#121212" : "#B7B7B7")};
  background: ${(p) => (p.selected ? "#F0F0F0" : "#fff")};

  svg path {
    stroke: ${(p) => (p.selected ? "#121212" : "#B7B7B7")};
  }
`;

export const EditTournamentTabWrapper = styled.div`
  height: 42px;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
`;

export const EditTournamentTabItem = styled.div<{ selected: boolean }>`
  height: 42px;
  padding: 0 16px;
  box-sizing: border-box;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  display: flex;
  align-items: center;
  color: ${(p) => (p.selected ? "#6436e7" : "#B7B7B7")};
  border-bottom: ${(p) => (p.selected ? "2px solid #6436e7" : "none")};
  cursor: pointer;
  white-space: nowrap;
`;

export const EditTournamentButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  display: flex;
  gap: 20px;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  border-top: 1px solid #f0f0f0;
  background: #fff;

  > .button {
    flex: 1;
    display: flex;
    padding: 12px 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 14px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
    background: #f0f0f0;
    color: #121212;
    cursor: pointer;
  }

  > .purple {
    color: #fff;
    background: #6436e7;
  }
`;

export const EditTournamentCheckBox = styled.div<{ isMobile?: boolean }>`
  position: relative;

  > img {
    position: absolute;
    top: ${(p) => (p.isMobile ? "5px" : "7px")};
    left: ${(p) => (p.isMobile ? "5px" : "5px")};
    pointer-events: none;
    width: ${(p) => (p.isMobile ? "10.6px" : "auto")};
  }

  input[type="checkbox"] {
    appearance: none;
    width: ${(p) => (p.isMobile ? "20px" : "22px")};
    height: ${(p) => (p.isMobile ? "20px" : "22px")};
    border-radius: ${(p) => (p.isMobile ? "4px" : "none")};
    border: 2px solid #d9d9d9;
    background-color: #fff;
    vertical-align: bottom;
    cursor: pointer;
    margin: 0;
    border: 1.3px solid #d9d9d9;
  }

  input[type="checkbox"]:checked {
    border: 1px solid #d9d9d9;
    background-color: #7f25fb;
  }
`;

export const EditTournamentCheckBoxWrapper = styled.div<{
  $weight?: string;
}>`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
  color: #fff;
  text-align: right;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */

  > .name {
    font-family: Pretendard;
    font-weight: ${(p) => (p.$weight ? p.$weight : "600")};
    font-size: 15px;
    color: #121212;
  }

  > .level {
    display: flex;
    height: 30px;
    box-sizing: border-box;
    padding: 0 11px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 10px;
    background: linear-gradient(
      90deg,
      #6c36d6 0%,
      #6f39d9 7.14%,
      #723cdc 14.29%,
      #743fdf 21.43%,
      #7742e2 28.57%,
      #7a45e5 35.71%,
      #7d48e7 42.86%,
      #804bea 50%,
      #834eed 57.14%,
      #8651f0 64.29%,
      #8954f3 71.43%,
      #8c57f6 78.57%,
      #8f59f9 85.71%,
      #925cfc 92.86%,
      #955fff 100%
    );
  }

  > .break {
    display: flex;
    height: 30px;
    box-sizing: border-box;
    padding: 0 11px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 10px;
    background: #bebebe;
  }
`;
